module.exports = "https://static.wmbcdn.com/uniweb/images/e71ef0c03ac467dabc200e5f8a60e8b6.svg";